namespace TotalPoll {
    import UniqueIdService = TotalCore.Common.Providers.UniqueIdService;
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'questions-component-template',
        bindings: {
            items: '=',
        }
    })
    class QuestionsComponent {
        public currentQuestion;
        public items: any[];

        constructor(private UniqueIdService: UniqueIdService) {

        }

        $onChanges() {
            if (!this.currentQuestion) {
                if (this.items.length === 0) {
                    this.addQuestion();
                }
                this.setCurrentQuestion(this.items.length - 1);
            }
        }

        addQuestion() {
            this.items.push({
                uid: this.UniqueIdService.generate(),
                content: '',
                settings: {
                    selection: {
                        minimum: 1,
                        maximum: 1,
                    }
                },
                choices: []
            });

            this.setCurrentQuestion(this.items.length - 1)
        }

        deleteQuestion(questionIndex, confirmed = false, resetPosition = true) {
            if (confirmed || confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items.splice(questionIndex, 1);
                if (resetPosition) {
                    questionIndex = questionIndex > 0 ? questionIndex - 1 : questionIndex;
                    this.setCurrentQuestion(questionIndex);
                }
            }
        }

        getCurrentQuestion() {
            return this.currentQuestion;
        }

        isCurrentQuestion(uid) {
            return this.currentQuestion && this.currentQuestion.uid === uid;
        }

        setCurrentQuestion(index) {
            this.currentQuestion = this.items[index];
        }
    }
}